module.exports = __webpack_public_path__ + "static/media/export.55a70c67.svg";